<template>

  <div id="app">
    <div class="container">
      <ProductDetail v-for="id of ids" :productId="id" :key="'product' + id" class="mb-3"/>
    </div>
  </div>
</template>

<script>
import ProductDetail from './components/ProductDetail.vue'
import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  name: 'app',
  data: () => {
    return {
      ids: [],
    }
  },
  components: {
    ProductDetail
  },
  mounted() {
    const elem = document.getElementById('sms-shop-app-products')
    if (elem) {
      const ids = JSON.parse(elem.textContent)
      this.ids = ids
    }
  }
}
</script>

<style lang="scss">
  $primary-color: #e6007e;
  $bg-color: #fdf7fa;

  .card.active {
    background-color: $primary-color;
    color: #ffffff;
  }
  .btn-primary {
    background-color: $primary-color;
    border-color: $primary-color;
  }
  .btn-primary:hover {
    background-color: #000000;
    border-color: #000000;
  }
  .btn-outline-primary {
    border-color: $primary-color;
    color: $primary-color;
  }
  .alert-primary {
    background-color: $bg-color;
    border-color: $primary-color;
    color: $primary-color;
  }
</style>